type PrivacyProps = {}

const Privacy = () => {
    return <>En développement.</>
}

export default Privacy
